var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 9",
    style: {
      enableBackground: "new 0 0 12 9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2,7.5c0,0.4-0.3,0.8-0.8,0.8h-9c-0.4,0-0.8-0.3-0.8-0.8V3c0-0.4,0.3-0.8,0.8-0.8h0.9C3,2.2,3.5,2,4,1.6L4.6,1 c0.1-0.1,0.3-0.2,0.5-0.2h1.8c0.2,0,0.4,0.1,0.5,0.2L8,1.6C8.5,2,9,2.3,9.6,2.2h0.9c0.4,0,0.8,0.3,0.8,0.8V7.5z M1.5,1.5 C0.7,1.5,0,2.2,0,3v4.5C0,8.3,0.7,9,1.5,9h9C11.3,9,12,8.3,12,7.5V3c0-0.8-0.7-1.5-1.5-1.5H9.6c-0.4,0-0.8-0.2-1.1-0.4L7.9,0.4 C7.7,0.2,7.3,0,6.9,0H5.1C4.7,0,4.3,0.2,4.1,0.4L3.4,1.1C3.2,1.3,2.8,1.5,2.4,1.5H1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6,6.8c-1,0-1.9-0.8-1.9-1.9S5,3,6,3s1.9,0.8,1.9,1.9S7,6.8,6,6.8z M6,7.5c1.4,0,2.6-1.2,2.6-2.6S7.4,2.2,6,2.2 S3.4,3.4,3.4,4.9S4.6,7.5,6,7.5z M2.2,3.4c0,0.2-0.2,0.4-0.4,0.4S1.5,3.6,1.5,3.4S1.7,3,1.9,3S2.2,3.2,2.2,3.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon_camera.6934fe571c3b9f76951fbad779ad6206.svg";
export { ForwardRef as ReactComponent };